import {
  Box,
  Typography,
  Card,
  CardHeader,
  Stack,
  Table,
  Skeleton,
  TableCell,
  TableHead,
  TableRow,
  TableContainer
} from "@mui/material";
import DashedDivider from "common/ui/DashedDivider";
import { ReactComponent as FilterIcon } from "assets/icons/filter-funnel.svg";
import { ReactComponent as ClearFilter } from "assets/icons/clear-filter.svg";
import _ from "lodash";
import { useTranslation } from "react-i18next";

function AuditLogsListFallback() {
  const { t } = useTranslation();
  return (
    <Card variant="outlined" className="highlight">
      <CardHeader
        sx={{ marginX: 2 }}
        title={
          <Stack direction="row">
            <Typography variant="h6" alignSelf="center">
              {t("auditLogsList.title")}
            </Typography>
          </Stack>
        }
        disableTypography
        action={
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" height={40} width={150} />
            <Skeleton variant="rounded" height={40} width={350} />
          </Stack>
        }
      />

      <DashedDivider style={{ width: "97%" }} />

      <Box padding={0.5} marginX={2} marginTop={1} bgcolor="grey.100">
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          my={1}
          px={1}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1} alignItems="center" my={1} px={1}>
            <FilterIcon style={{ height: 32, width: 32 }} />
            <Typography
              variant="h6"
              alignSelf="center"
              style={{ minWidth: "200px" }}
              fontWeight="regular"
              color="gray.main"
            >
              {t("auditLogsList.filterAuditLogs")}
            </Typography>

            <Skeleton variant="rounded" height={40} sx={{ width: 320 }} />
            <Skeleton variant="rounded" height={40} sx={{ width: 340 }} />
          </Stack>
          <Box display="flex" alignItems="flex-end" sx={{ cursor: "pointer" }}>
            <ClearFilter style={{ width: 38, height: 38 }} />
          </Box>
        </Stack>
      </Box>

      <TableContainer sx={{ paddingX: 2 }}>
        <Table>
          <TableHead>
            {_.range(10).map((rowId) => (
              <TableRow key={rowId}>
                {_.range(5).map((cellId) => (
                  <TableCell key={cellId}>
                    <Skeleton />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
        </Table>
        <Stack direction="row" justifyContent="center" my={1} spacing={2}>
          <Skeleton variant="rounded" width={60} height={30} />
          <Skeleton variant="rounded" width={30} height={30} />
          <Skeleton variant="rounded" width={30} height={30} />
          <Skeleton variant="rounded" width={30} height={30} />
          <Skeleton variant="rounded" width={60} height={30} />
        </Stack>
      </TableContainer>
    </Card>
  );
}

export default AuditLogsListFallback;
